// Assuming the types for login, useNavigate, LoginResponse, and other types are defined in separate files

import React from 'react'
import Layout from '../../components/Layout'
import { Button } from '../../../../components'
import { PageRoute } from '../../../../routes'
import { useNavigate } from 'react-router-dom'
import { Logoutbanner } from '../../../../assets/images'
import { useTranslation } from 'react-i18next'

const Logout: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <Layout pageTitle="Successfully Logged Out" bannerImage={Logoutbanner}>
            <Button
                onClick={() => {
                    navigate(PageRoute.Login)
                }}
                variant="outline-success-round"
            >
                {t('button.backToLogin')}
            </Button>
        </Layout>
    )
}

export default Logout
